import { useState } from "react";
import { cn } from "@/lib/utils";
import { mediaUrl } from "@/lib/media";

type Props = {
  url?: string | null;
  emoji?: string | null;
  size?: number;
  className?: string;
  rounded?: "full" | "md";
};

export function UserAvatar({ url, emoji, size = 40, className, rounded = "full" }: Props) {
  const radius = rounded === "full" ? "rounded-full" : "rounded-md";
  const style = { width: size, height: size, fontSize: Math.round(size * 0.55) };
  const src = mediaUrl(url);
  // If the image fails to load, fall back to the emoji tile instead of the
  // browser's broken-image icon.
  const [broken, setBroken] = useState(false);

  if (src && !broken) {
    return (
      <img
        src={src}
        alt=""
        style={style}
        className={cn(radius, "object-cover bg-muted shrink-0", className)}
        loading="lazy"
        onError={() => setBroken(true)}
      />
    );
  }
  return (
    <div
      style={style}
      className={cn(
        radius,
        "bg-muted flex items-center justify-center leading-none shrink-0 select-none",
        className,
      )}
    >
      <span>{emoji || "⚽"}</span>
    </div>
  );
}
